import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService } from '../core/services/auth.service';
import { UserProfileService } from '../core/services/user.service';
import { LogService } from '../core/services/log.service';
import { DashboardService } from '../pages/dashboard/services/dashboard.service';
import { firstValueFrom } from 'rxjs';
declare global {
  interface Window {
    pendo: { initialize: (options: object) => void };
  }
}
@Component({
    selector: 'app-layout-container',
    templateUrl: './layout-container.component.html',
    styleUrls: ['./layout-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LayoutContainerComponent implements OnInit {
  constructor(
    public authService: AuthenticationService,
    public userService: UserProfileService,
    private readonly logService: LogService,
    private readonly dashboardService: DashboardService,
  ) { }
  async initUser() {
    await this.authService.initUser();
    await this.userService.getUser();
    await this.initializeDashboardNavigation();
    this.userService.mapActions();
    this.logService.setupDataDog();
    this.setupPendo(this.userService.USER_PROFILE?._id);
    this.logService.info('Logger Setup Successfull');
  }

  async initializeDashboardNavigation() {
    try {
      const dashboardResponse = await firstValueFrom(this.dashboardService.getUserDashboards());
      this.dashboardService.buildNavFromModules(
        dashboardResponse?.data?.dashboards || [],
        dashboardResponse?.data?.menuSections || {},
      );
    } catch (e) {
      this.logService.error(e);
      this.dashboardService.buildNavFromModules([]);
    }
  }
  ngOnInit() {
    this.initUser();
  }
  setupPendo(userId: string) {
    try {
      (globalThis as any)?.pendo?.initialize({
        visitor: {
          id: userId   // Required if user is logged in, default creates anonymous ID
        },
        account: {
          id: 'ACCOUNT-UNIQUE-ID' // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
        }
      });
    }
    catch (e) {
      this.logService.error(e)
    }
  }
}
